import { toast } from "react-toastify";
import LoadTypes from "../../../api/load-types";

export const loadTypes = {
  state: {
    types: [],
  },
  reducers: {
    setLoadTypes(state, payload) {
      return {
        ...state,
        types: payload,
      };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async loadAsync(payload, rootState) {
      try {
        const { data } = await LoadTypes.list();
        this.setLoadTypes(data);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
  }),
};
